import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../css/others/Table.css";
import { apiCall } from "../main/ApiCall";
import { MeetingTrackerDetailsInfoResponse } from "../interFaces/interfaces"
import BackButton from "../Reusablecomponents/BackButton";
const MeetingTrackerDetailsInfo: React.FC = () => {
    const { campaignId, projectId } = useParams<{ campaignId: string; projectId: string; }>();
    const clientId = localStorage.getItem("clientId");
    const [data, setData] = useState<MeetingTrackerDetailsInfoResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const fetchDetailsInfo = useCallback(async () => {
        if (!campaignId || !projectId) return;
        setLoading(true);
        try {
            const response = await apiCall("get", `/api/meeting-tracking/${clientId}/${campaignId}/${projectId}`);
            setData(response);
        } catch (error) {
            console.error("Failed to fetch meeting tracker details info", error);
        } finally {
            setLoading(false);
        }
    }, [clientId, campaignId, projectId]);
    useEffect(() => {
        fetchDetailsInfo();
    }, [fetchDetailsInfo]);
    return (
        <div className="table-details">
            <div className="table-title">
                <h2>Meeting Tracker Project Details</h2>
            </div>
            <div className="table-container">
                <div className="table-inner-container">
                    <table className="main-table">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Status</th>
                                <th>Response Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={4} className="no-data">Loading..</td>
                                </tr>
                            ) : data?.detailedResponses?.length ? (
                                data.detailedResponses.map((res, index) => (
                                    <tr key={index}>
                                        <td>{res.email}</td>
                                        <td>{res.role}</td>
                                        <td><span className={`status ${res.responseStatus.toLowerCase()}`}>{res.responseStatus}</span></td>
                                        <td>{new Date(res.responseTime).toLocaleString()}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="no-data">No response data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="buttons">
                <BackButton className="back-button2" label="Back" />
            </div>
        </div>
    );
};
export default MeetingTrackerDetailsInfo;